import type { CSSObject } from '@emotion/react'
import { FontWeight, Spacing, Typography, Color, Theme } from '@opallabs/gem'

export const container: CSSObject = {
  inlineSize: '100%',
}

export const label = (theme: Theme): CSSObject => ({
  ...Typography.T500,
  color: Color[theme].Text.Default,
  fontWeight: FontWeight.Bold,
  marginBlockEnd: Spacing.M,
})

export const description = (theme: Theme): CSSObject => ({
  ...Typography.T500,
  color: Color[theme].Text.Gray,
  fontWeight: FontWeight.Medium,
})

export const field = (theme: Theme): CSSObject => ({
  ...Typography.T300,
  color: Color[theme].Text.Default,
  fontWeight: FontWeight.Medium,
  marginBlockEnd: Spacing.L,
  '& > p': {
    marginBlockEnd: Spacing.S,
  },
})

export const title: CSSObject = {
  fontSize: 14,
}
